import { Constants, BooleanToIntegerConstants } from "../core/common/Constants";

const arrayToTree = (
  items: any[],
  id: any = null,
  link: string = "parentId",
  target: string = "children"
) => {
  return items
    ?.filter((item) => item[link] === id)
    .map((item) => ({
      ...item,
      [target]: arrayToTree(items, item.id, link, target)
    }));
};
export function parseBooleanValue(value: boolean) {
  return value ? Constants.TRUE : Constants.FALSE;
}
export function formatBooleanValue(value: string) {
  return value === Constants.TRUE;
}
export function formatBooleanValueFromInteger(value: number) {
  return value === BooleanToIntegerConstants.TRUE;
}

export { arrayToTree };
